import {
    CUSTOM_RANGE,
    DASHBOARD,
    DASHBOARD_BAR_PERFORMANCE,
    DASHBOARD_OUTDOOR_CONDITIONS,
    DASHBOARD_SMOKE_READINESS,
    DASHBOARD_SMOKE_SITE_DETAIL,
    DASHBOARD_ZONES_NEEDING_ACTION,
    DASHBOARD_ZONE_DETAIL,
    DASHBOARD_CLOSING_THE_LOOP,
    DASHBOARD_DEVICE_ALERTS,
    DASHBOARD_PERFORMANCE,
    DASHBOARD_PERFORMANCE_RANGE,
} from 'containers/urlConstant';
import { http_get, http_post } from './BaseURLAxios';
import { Performance_Benefits } from 'shared/utils/Constants';
import { IDASHBOARDGRAPH } from 'redux/types';
import { ClosingTheLoopPayload } from 'views/dashboard/closingTheLoop/types';
import { OutdoorConditionsPayload } from 'views/dashboard/outdoor/types';
import { normalizeOutdoorConditionsPayload } from 'views/dashboard/outdoor/outdoorConditionsUtils';
import { SmokeReadinessPayload, SmokeSiteDetail } from 'views/dashboard/smoke/types';
import { ZoneDetail, ZonesNeedingActionPayload } from 'views/dashboard/zones/types';
import { DeviceAlertsOverlayPayload } from 'views/dashboard/deviceAlerts/types';

export const getOutdoorConditions = async (): Promise<OutdoorConditionsPayload> => {
    const data = await http_get(DASHBOARD_OUTDOOR_CONDITIONS);
    return normalizeOutdoorConditionsPayload(data);
};

export const getSmokeReadiness = async (): Promise<SmokeReadinessPayload> => {
    const data = await http_get(DASHBOARD_SMOKE_READINESS);
    return data as SmokeReadinessPayload;
};

export const getSmokeSiteDetail = async (siteId: number): Promise<SmokeSiteDetail> => {
    const data = await http_get(`${DASHBOARD_SMOKE_SITE_DETAIL}/${siteId}`);
    return data as SmokeSiteDetail;
};

export const getZonesNeedingAction = async (): Promise<ZonesNeedingActionPayload> => {
    const data = await http_get(DASHBOARD_ZONES_NEEDING_ACTION);
    return data as ZonesNeedingActionPayload;
};

export const getZoneDetail = async (zoneId: number): Promise<ZoneDetail> => {
    const data = await http_get(`${DASHBOARD_ZONE_DETAIL}/${zoneId}`);
    return data as ZoneDetail;
};

export const getZoneGraphData = async (
    zoneId: number,
    timestamp: string,
    deviceList: string[],
): Promise<IDASHBOARDGRAPH> => {
    return await http_post(`${DASHBOARD_ZONE_DETAIL}/${zoneId}/graph/${timestamp}`, {
        device_list: deviceList,
    }).then((res: any) => res);
};

export const getDeviceAlertsOverlay = async (): Promise<DeviceAlertsOverlayPayload> => {
    const data = await http_get(DASHBOARD_DEVICE_ALERTS);
    return data as DeviceAlertsOverlayPayload;
};

export const getClosingTheLoop = async (): Promise<ClosingTheLoopPayload> => {
    const data = await http_get(DASHBOARD_CLOSING_THE_LOOP);
    return data as ClosingTheLoopPayload;
};

export const getDashboardData = async () => {
    return await http_get(DASHBOARD).then((res: any) => {
        return res;
    });
};

export const getDashboardPerformaceGraphData = async (type: string, timestamp: string) => {
    return await http_get(DASHBOARD_PERFORMANCE + '/' + type + '/' + timestamp).then((res: any) => {
        return res;
    });
};

export const getDashboardPerformaceBarData = async () => {
    return await http_get(DASHBOARD_BAR_PERFORMANCE).then((res: any) => {
        return res;
    });
};

export const getRanges = async () => {
    return await http_get(DASHBOARD_PERFORMANCE_RANGE).then((res: any) => {
        return res;
    });
};
export const getDashboardCustomRangeData = async (
    type: Performance_Benefits,
    startTime: string,
    endTime: string,
): Promise<IDASHBOARDGRAPH> => {
    return await http_get(
        `${DASHBOARD_PERFORMANCE}/${type}${CUSTOM_RANGE}?start_time=${startTime}&end_time=${endTime}`,
    ).then((res: any) => {
        return res;
    });
};
